import { styled } from "@mui/material/styles";
import { Layout } from "$components";
import { theme } from "$utils/theme/bataillog";
import { CompanyType } from "$types/CompanyType";

import { CompanyHeader } from "./sections/CompanyHeader";
import { DisplayCompanyTabs } from "./sections/DisplayCompanyTabs";
import { ResumeCompany } from "./sections/ResumeCompany";
import { Contacts } from "./sections/Contacts";
import { ResumeCarrier } from "./sections/ResumeCarrier";
import { ResumeWarehouse } from "./sections/ResumeWarehouse";
import { useEntrepriseProfileLogic } from "./hooks/useEntrepriseProfileLogic";

const ContentWrapper = styled("div")({
  paddingBottom: theme.spacing(2),
});

export function EntrepriseProfile() {
  const {
    id,
    company,
    isLoading,
    isLoadingUsers,
    userList,
    selectedTab,
    selectedCompanyTypes,
    handleTabChange,
    contributors,
    clients,
    carrier,
    logiWarehouse,
    clientsWithCatalogue,
    getCompany,
    control,
    redirect,
    cantEditCurrentTab,
  } = useEntrepriseProfileLogic();

  return (
    <Layout
      renderHead={() => <CompanyHeader company={company} />}
      title={company?.name}
    >
      <ContentWrapper>
        <DisplayCompanyTabs company={company} onChange={handleTabChange} />

        <ResumeCompany
          company={company}
          cantEditCurrentTab={cantEditCurrentTab}
          selectedTab={selectedTab}
          contributors={contributors}
          clients={clients}
          carrier={carrier}
          logiWarehouse={logiWarehouse}
          clientsWithCatalogue={clientsWithCatalogue}
          isLoading={isLoading}
        />

        <Contacts
          company={company}
          cantEditCurrentTab={!cantEditCurrentTab}
          companyTypes={selectedCompanyTypes}
          isDisabled={cantEditCurrentTab}
          isLoading={isLoadingUsers}
          userList={userList}
          id={id}
        />

        <ResumeCarrier
          company={company}
          fetchCompany={getCompany}
          redirect={redirect}
          control={control}
          selectedTab={selectedTab}
        />

        {selectedCompanyTypes?.some((c) =>
          [
            CompanyType.CLIENT,
            CompanyType.CONTRIBUTOR,
            CompanyType.LOGISTICIAN,
          ].includes(c)
        ) && (
          <ResumeWarehouse
            company={company}
            companyId={id}
            selectedTab={selectedCompanyTypes}
            contributors={contributors}
            clients={clients}
            isDisabled={cantEditCurrentTab}
            redirect={redirect}
          />
        )}
      </ContentWrapper>
    </Layout>
  );
}

export default EntrepriseProfile;
